var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('button',{ref:"loadBtn",on:{"click":_vm.loadMap}},[_vm._v("Build Map")]),_c('SVGLayout',{ref:"map",attrs:{"location":"./img/TableLayout_no_animations.svg","prefix":"","idfield":"name","status":_vm.status,"status_map":_vm.status_map},on:{"select":_vm.clicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }